var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M505 41L320 225.93V488c0 19.51-22 30.71-37.76 19.66l-80-56A24 24 0 0 1 192 432V226L7 41C-8 25.87 2.69 0 24 0h464c21.33 0 32 25.9 17 41z","className":"fa-secondary","key":1})]);
}

Filter.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Filter;

Filter.default = Filter;
